import blobToBuffer from 'blob-to-buffer';
import $root from '../../static/proto-bundle';

class CallBuider {

  createCreateSlotRequestBody(c) {
    const builder = $root.lookup('CreateSlotRequest');
    const payload = builder.create({
      username: c.username,
      pin: c.pin
    });
    return builder.encode(payload).finish();
  }

  createPingBody() {
    const builder = $root.lookup('ConnectRequests');
    const payload = builder.create({
      ping: 0
    });
    return builder.encode(payload).finish();
  }

  createSessionDescriptionBody(data, sequence) {
    const connectRequests = $root.lookup('ConnectRequests');
    const dataMessage = $root.lookup('DataMessage');
    const payload = connectRequests.create({
      webrtcMessage: {
        sequence,
        data: dataMessage.create({
          sessionsDescription: {
            type: 1,
            description: data.sdp
          }
        })
      }
    });
    return connectRequests.encode(payload).finish();
  }

  createIceCandidateBody(sdp, sequence) {
    const connectRequests = $root.lookup('ConnectRequests');
    const dataMessage = $root.lookup('DataMessage');
    const payload = connectRequests.create({
      webrtcMessage: {
        sequence,
        data: dataMessage.create({
          iceCandidateAdd: {
            iceCandidate: [{
              sdpMid: sdp.sdpMid,
              sdpMLineIndex: sdp.sdpMLineIndex,
              sdp: sdp.candidate
            }]
          }
        })
      }
    });
    return connectRequests.encode(payload).finish();
  }

  createMuteRequestBody(val) {
    const builder = $root.lookup('MuteRequest');
    const payload = builder.create({
      mute: val
    });
    return builder.encode(payload).finish();
  }

  createLockRequestBody(val) {
    const builder = $root.lookup('LockRequest');
    const payload = builder.create({
      lock: val
    });
    return builder.encode(payload).finish();
  }

  createEndSlotRequest() {
    const builder = $root.lookup('EndSlotRequest');
    const payload = builder.create({
      reason: 1,
      clientMessage: 'user wished to leave the conference'
    });
    return builder.encode(payload).finish();
  }

  createTitleRequestBody(title) {
    const builder = $root.lookup('TitleRequest');
    const payload = builder.create({ title });
    return builder.encode(payload).finish();
  }

  createMuteUserRequestBody(userId) {
    const builder = $root.lookup('MuteUserRequest');
    const payload = builder.create({ userId });
    return builder.encode(payload).finish();
  }

  createUnmuteUserRequestBody(userId) {
    const builder = $root.lookup('UnmuteUserRequest');
    const payload = builder.create({ userId });
    return builder.encode(payload).finish();
  }

  createKickUserRequestBody(userId) {
    const builder = $root.lookup('KickUserRequest');
    const payload = builder.create({ userId });
    return builder.encode(payload).finish();
  }

  createPutAdminRequestBody(isAdmin) {
    const builder = $root.lookup('PutAdminRequest');
    const payload = builder.create({ isAdmin });
    return builder.encode(payload).finish();
  }

  decodeCreateSlotResponse(payload) {
    const container = $root.lookup('CreateSlotResponse');
    return container.decode(new Uint8Array(payload));
  }

  decodeCreateSlotError(payload) {
    const container = $root.lookup('CreateSlotError');
    return container.decode(new Uint8Array(payload));
  }

  decodeConnectResponses(payload) {
    return new Promise((resolve, reject) => {
      blobToBuffer(payload, (err, buffer) => {
        const container = $root.lookup('ConnectResponses');
        const message = container.decode(new Uint8Array(buffer));
        resolve(message);
      });
    });
  }

  decodePhoenix(payload, callback) {
    blobToBuffer(payload, (err, buffer) => {
      const container = $root.lookup('CallChannel');
      const message = container.decode(new Uint8Array(buffer));
      console.info('phoenix', message);
      callback(message.toJSON());
    });
  }

  decodeCallChannel(payload, callback) {
    blobToBuffer(payload, (err, buffer) => {
      const container = $root.lookup('CallChannel');
      const message = container.decode(new Uint8Array(buffer));
      const normalized = this.adjustToPhoenixProtocol(message.toJSON());
      if (
        normalized.payload.participantsCount &&
        normalized.payload.participantsCount.update) {
        if (callback) {
          callback(normalized.payload.participantsCount.update);
        }
      }
    });
  }

  adjustToPhoenixProtocol(message) {
    if (message.event === 'phx_reply' && message.replyStatus) {
      if (!message.payload) {
        message.payload = {};
      }
      message.payload.status = message.replyStatus;
    }

    if (message.event === 'phx_close') {
      message.payload = {
        status: 'ok'
      };
    }

    return message;
  }
}

export default CallBuider;



// WEBPACK FOOTER //
// ./src/services/call-builder.service.js